__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/phx-rel-r25.9.4-21sep20259amist/_next/";